const state = {
  connection: false,
  eventSource: undefined,
  onecStates: {}
};

const getters = {
  connection: state => state.connection,
  eventSource: state => state.eventSource,
  onecStates: state => state.onecStates,
}

const actions = {
  async parseEventData(_, evt) {
    return JSON.parse(evt.data)
  },
  async initOnecStream({dispatch, commit}) {
    await commit('dropEventSource')
    let eventSource
    try {
      eventSource = new EventSource(`/sse/our_legal_entities/onec/check/subscribe?auth_token=${localStorage.getItem('authHeader')}`)
    } catch(e) {
      console.error(e)
      await commit('dropEventSource')
    }
    commit('setEventSource', eventSource)
    commit('setConnection', true)
    eventSource.addEventListener('error', (e)=>{dispatch('streamError', e)})
    eventSource.addEventListener('update', (e)=>{dispatch('updateOnecStates', e)})
    eventSource.addEventListener('drop', (e)=>{dispatch('streamDrop', e)})
    commit('resetOnecStates')
  },
  async streamError({commit}, e) {
    await commit('showSnackbar', {
      color: 'error',
      text: 'Синхронизация 1С прервана, потеряно соединнеие с сервером.',
    })
    console.error(e)
    await commit('dropEventSource')
    await commit('setConnection', false)
  },
  async updateOnecStates({commit, dispatch}, data) {
    await commit('addOnecState', await dispatch('parseEventData', data))
  },
  async streamDrop({commit}) {
    await commit('dropEventSource')
    await commit('setConnection', false)
    // await commit('showSnackbar', {
    //   color: 'success',
    //   text: 'Синхронизация 1С завершена.',
    // })
  },
};

const mutations = {
  setEventSource(state, eventSource) {
    state.eventSource = eventSource
  },
  setConnection(state, connection) {
    state.connection = connection
  },
  addOnecState(state, data) {
    state.onecStates[data.id] = data
    state.onecStates = {...state.onecStates}
  },
  resetOnecStates(state) {
    state.onecStates = {}
  },
  dropEventSource(state) {
    if (state.eventSource) {
      state.eventSource.close()
    }
    state.connection = false
    state.eventSource = undefined
  },
};

export default {
    state,
    getters,
    actions,
    mutations
};
